import React from 'react';
import ReactDOM from 'react-dom';
interface SuccessProps {
  addUser: () => void;
  viewUser: () => void;
  download: () => void;
  upload: () => void;
  confirm: () => void;
  emailId?: string;
  isUpdate?: string;
  nameOfScreen: string;
  isApproval?: string;
  statusValue?: string;
  role?: string;
  name?: string;
  isEvent?: string;
}
const Sucesspopup: React.FC<SuccessProps> = ({
  addUser,
  download,
  upload,
  viewUser,
  confirm,
  emailId,
  isUpdate,
  nameOfScreen,
  isApproval,
  statusValue,
  role,
  name,
  isEvent,
}) => {
  console.log(isUpdate);
  console.log(role);
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-30">
      <div className="bg-white rounded-lg shadow-lg overflow-hidden w-[500px]">
        <div className="p-6">
          <div className="flex items-center justify-center">
            <div className="ml-4">
              {nameOfScreen === 'users' && (
                <>
                  <h3 className="text-lg font-bold text-gray-900 text-center">
                    {isUpdate == 'add' ? 'Success!' : 'Update Successful!'}{' '}
                  </h3>
                </>
              )}
              {nameOfScreen === 'leads' && (
                <>
                  <h3 className="text-lg font-bold text-gray-900 text-center">
                    {isUpdate == 'add'
                      ? 'Lead Saved Successfully!'
                      : 'Lead Updated Successfully!'}{' '}
                  </h3>
                </>
              )}

              {nameOfScreen === 'companies' && (
                <>
                  <h3 className="text-lg font-bold text-gray-900 text-center">
                    {isUpdate == 'add'
                      ? 'Company Saved Successfully!'
                      : 'Company Updated Successfully!'}{' '}
                  </h3>
                </>
              )}

              {nameOfScreen === 'trendingNow' && (
                <>
                  <h3 className="text-lg font-bold text-gray-900 text-center">
                    Maximum Limit Reached
                  </h3>
                </>
              )}

              {nameOfScreen === 'proposals' && (
                <>
                  <h3 className="text-lg font-bold text-gray-900 text-center">
                    {isUpdate == 'add'
                      ? 'Proposal Saved Successfully!'
                      : isUpdate == 'adminInvite'
                      ? ' Vendor Invited & Dashboard Activated!'
                      : isUpdate == 'adminTrail'
                      ? 'Vendor Trailed & Dashboard Activated!'
                      : isUpdate == 'INVITE'
                      ? ' Dashboard Activated!'
                      : isUpdate == 'TRIAL'
                      ? 'Dashboard Activated!'
                      : isUpdate == 'updateConfirmBooking'
                      ? 'Order form updated'
                      : isUpdate == 'confirmBook'
                      ? 'Order form Confirmed'
                      : 'Information Updated Successfully!'}
                  </h3>
                </>
              )}

              {nameOfScreen === 'bookings' && (
                <>
                  <h3 className="text-lg font-bold text-gray-900">
                    Booking Successful{' '}
                  </h3>
                </>
              )}
              {nameOfScreen === 'upload' && (
                <>
                  <h3 className="text-lg font-bold text-gray-900">
                    Upload Confirmation
                  </h3>
                </>
              )}

              {nameOfScreen === 'posts' && (
                <>
                  {isApproval == 'draft' && (
                    <h3 className="text-lg font-bold text-gray-900 text-center">
                      {isUpdate == 'update'
                        ? 'Draft Saved Successfully'
                        : 'Draft Saved Successfully'}{' '}
                    </h3>
                  )}
                  {isApproval == 'approval' && (
                    <h3 className="text-lg font-bold text-gray-900 text-center">
                      {isUpdate == 'update' && statusValue === 'PUBLISHED'
                        ? 'Post Updated'
                        : role === 'JE' || role === 'CE'
                        ? 'Post Submitted for Approval'
                        : role === 'Publisher' && isEvent === 'events'
                        ? 'Event Sent Successfully'
                        : role === 'Publisher' &&
                          userInfo?.roles !== 'PUBLISHER'
                        ? 'Post Sent Successfully'
                        : isEvent === 'events'
                        ? 'Event Posted Successfully!'
                        : 'Post published successfully!'}{' '}
                    </h3>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="ml-4 mt-3">
            {isUpdate == 'add' && nameOfScreen === 'users' && (
              <h3 className="text-base font-medium text-gray-900 text-center">
                User added successfully! An invitation email has been sent to{' '}
                <b> {emailId}</b>. Please ask the user to accept the invitation
                within 3 days to complete the registration.
              </h3>
            )}
            {nameOfScreen === 'leads' && (
              <>
                {isUpdate == 'add' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    Your lead has been saved successfully. You can now manage it
                    from the Leads section and keep track of any further actions
                    needed.
                  </h3>
                )}
                {isUpdate == 'update' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    Your lead has been Updated successfully. You can now manage
                    it from the Leads section and keep track of any further
                    actions needed.
                  </h3>
                )}
              </>
            )}

            {nameOfScreen === 'trendingNow' && (
              <>
                {name === 'isFeatured' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    You can only add up to {name === 'isFeatured' ? '7' : '5'}{' '}
                    posts in this section. Please remove an existing post to add
                    a new one.
                  </h3>
                )}
                {name === 'isEvent' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    You can only add up to 5 events in this section. Please
                    remove an existing event to add a new one.
                  </h3>
                )}
                {name == 'trendingNowLimit' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    You can only add up to 5 posts in the 'Trending Now'
                    section. Please remove an existing post to add a new one.
                  </h3>
                )}
                {name == 'videoLimit' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    You can only add up to 6 videos in the 'Videos' section. To
                    add a new video, please remove an existing one.
                  </h3>
                )}
              </>
            )}
            {nameOfScreen === 'companies' && (
              <>
                {isUpdate == 'add' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    Your Company has been saved successfully. You can now manage
                    it from the Companies section and keep track of any further
                    actions needed.
                  </h3>
                )}
                {isUpdate == 'update' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    Your Company has been Updated successfully. You can now
                    manage it from the Companies section and keep track of any
                    further actions needed.
                  </h3>
                )}
              </>
            )}

            {nameOfScreen === 'proposals' && (
              <>
                {isUpdate == 'add' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    Your Proposal has been saved successfully. You can now
                    manage it from the Proposals section and keep track of any
                    further actions needed.
                  </h3>
                )}
                {isUpdate == 'update' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    The details have been updated successfully.
                  </h3>
                )}
                {isUpdate == 'INVITE' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    The vendor’s dashboard has been successfully activated. They
                    can now access and manage their services.
                  </h3>
                )}
                {(isUpdate == 'adminInvite' || isUpdate == 'adminTrail') && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    {isUpdate == 'adminInvite'
                      ? 'The vendor has been invited and will receive an email with login details. Their dashboard is now active, and they can start managing their services.'
                      : 'The vendor has been trailed and will receive an email with login details. Their dashboard is now active, and they can start managing their services.'}
                  </h3>
                )}

                {isUpdate == 'TRIAL' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    The vendor’s dashboard has been successfully activated. They
                    can now access and manage their services.
                  </h3>
                )}
                {(isUpdate == 'confirmBook' ||
                  isUpdate === 'updateConfirmBooking') && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    The order form has been successfully generated and shared
                    with the vendor. Once the vendor signs and reuploads the
                    form, the contract will be activated.
                  </h3>
                )}
              </>
            )}

            {nameOfScreen === 'bookings' && (
              <>
                <h3 className="text-base font-medium text-gray-900 text-center">
                  The order form has been generated successfully!
                </h3>
              </>
            )}

            {nameOfScreen === 'upload' && (
              <>
                <h3 className="text-base font-medium text-gray-900 text-center">
                  Are you sure you want to upload this signed order form? Please
                  ensure all details are correct before proceeding.
                </h3>
              </>
            )}

            {nameOfScreen === 'posts' && (
              <>
                {isApproval == 'draft' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    {isUpdate == 'update' && userInfo.roles === 'PUBLISHER'
                      ? 'Your post has been saved as a draft. You can return to edit and publish it from your drafts section.'
                      : isUpdate
                      ? 'Your post has been saved as a draft. You can return to edit and submit it for approval anytime from your drafts section.'
                      : 'Your post has been saved as a draft. You can return to edit and submit it for approval anytime from your drafts section.'}
                  </h3>
                )}
                {/* <h3 className="text-lg font-bold text-gray-900 text-center">
                      {isUpdate == "update" && statusValue === "PUBLISHED"
                        ? "Post Updated" : (role ==='JE' || role ==='CE') ? 'Post Submitted for Approval'
                         : role === 'Publisher' ? 'Post Sent Successfully'
                        : "Content Posted Successfully!"}{" "}
                    </h3> */}
                {isApproval === 'approval' && (
                  <h3 className="text-base font-medium text-gray-900 text-center">
                    {isUpdate === 'update' &&
                    role !== 'JE' &&
                    role !== 'CE' &&
                    role !== 'Publisher' &&
                    userInfo.roles !== 'PUBLISHER'
                      ? 'Your content has been successfully updated. The previous version has been overwritten.'
                      : role === 'Publisher' && isEvent === 'events'
                      ? 'Your event has been successfully sent to publisher.'
                      : role === 'Publisher' && userInfo.roles !== 'PUBLISHER'
                      ? 'Your post has been successfully sent to publisher.'
                      : role === 'JE'
                      ? 'Your post has been successfully submitted to the Junior Editor for approval.'
                      : role === 'CE'
                      ? 'Your post has been successfully submitted to the Chief Editor for approval.'
                      : isEvent === 'events'
                      ? 'Your event has been successfully published and is now live for readers. '
                      : 'Your content has been successfully published and is now live for readers. '}
                  </h3>
                )}
              </>
            )}
            {isUpdate !== 'add' && nameOfScreen === 'users' && (
              <h3 className="text-base font-medium text-gray-900 text-center">
                The changes have been successfully updated.
              </h3>
            )}
          </div>
        </div>
        {nameOfScreen == 'trendingNow' && (
          <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2"
              onClick={viewUser}
            >
              Okay
            </button>
          </div>
        )}
        {isUpdate !== 'add' &&
          (nameOfScreen === 'users' ||
            nameOfScreen === 'leads' ||
            (nameOfScreen === 'posts' &&
              role !== 'JE' &&
              role !== 'CE' &&
              role !== 'Publisher') ||
            nameOfScreen === 'companies' ||
            nameOfScreen === 'proposals') && (
            <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
              <button
                type="button"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white  sm:ml-3 sm:w-auto sm:text-sm mr-2"
                onClick={viewUser}
              >
                {nameOfScreen === 'posts'
                  ? 'Close'
                  : isUpdate == 'confirmBook'
                  ? 'Okay, Got It'
                  : isUpdate == 'TRIAL' || isUpdate == 'INVITE'
                  ? 'Close'
                  : 'Okay'}
              </button>
            </div>
          )}

        {isUpdate === 'add' && nameOfScreen === 'users' && (
          <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm mr-2"
              onClick={viewUser}
            >
              View All Users
            </button>
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
              onClick={addUser}
            >
              Add Another User
            </button>
          </div>
        )}
        {isUpdate == 'add' && nameOfScreen === 'leads' && (
          <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm mr-2"
              onClick={viewUser}
            >
              View Leads
            </button>
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
              onClick={addUser}
            >
              Add Another Lead
            </button>
          </div>
        )}

        {isUpdate == 'add' && nameOfScreen === 'companies' && (
          <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm mr-2"
              onClick={viewUser}
            >
              View Companies
            </button>
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
              onClick={addUser}
            >
              Add Another Company
            </button>
          </div>
        )}

        {isUpdate == 'add' && nameOfScreen === 'proposals' && (
          <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm mr-2"
              onClick={viewUser}
            >
              View Proposals
            </button>
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
              onClick={addUser}
            >
              Add Another Proposal
            </button>
          </div>
        )}

        {(isUpdate === 'add' ||
          role == 'JE' ||
          role === 'CE' ||
          role === 'Publisher') &&
          nameOfScreen === 'posts' && (
            <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
              <button
                type="button"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm mr-2"
                onClick={viewUser}
              >
                View All Posts
              </button>

              {userInfo?.roles !== 'PUBLISHER' && (
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
                  onClick={addUser}
                >
                  Add Another Post
                </button>
              )}
            </div>
          )}

        {nameOfScreen === 'bookings' && (
          <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-bold text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
              // onClick={viewUser}
              onClick={download}
            >
              Download Now
            </button>
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-bold text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm mr-2"
              onClick={addUser}
            >
              View Booked Services
            </button>
          </div>
        )}

        {nameOfScreen === 'upload' && (
          <div className="bg-white-50 px-4 py-2 mb-4 sm:px-6 sm:flex justify-center sm:flex-row-revers">
            <button
              type="button"
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-bold text-gray-700 hover:bg-gray-50 sm:mt-0 sm:w-auto sm:text-sm"
              // onClick={viewUser}
              onClick={upload}
            >
              Cancel
            </button>
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 gradient-background text-base font-bold text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm mr-2"
              onClick={confirm}
            >
              Upload Now
            </button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default Sucesspopup;
